import { BaseAPIRequestFactory, RequiredError } from './baseapi';
import type { Configuration } from '../configuration';
import { RequestContext, HttpMethod, ResponseContext, HttpInfo } from '../http/http';
import { ObjectSerializer } from '../models/ObjectSerializer';
import { ApiException } from './exception';
import { isCodeInRange } from '../util';
import type {SecurityAuthentication} from '../auth/auth';
import type {HttpFile} from '../http/http';


import { ListUsersResponse } from '../models/ListUsersResponse';

/**
 * no description
 */
export class ListProjectUsersApiRequestFactory extends BaseAPIRequestFactory {

  /**
   * Get all users of a project
   * @param pageIndex The page index
   * @param pageSize The numbers of items per page
   * @param sort The sort order, field:direction
   * @param projectId The project ID
   * @param filter The filter to apply
   */
  public async listProjectUsers(pageIndex: number, pageSize: number, sort: string, projectId: string, filter?: string, _options?: Configuration): Promise<RequestContext> {
    let _config;
    if (!_options) {
      _config = this.configuration;
    } else {
      _config = Object.assign({}, _options, this.configuration);
    }
    


    // verify required parameter 'pageIndex' is not null or undefined
    if (pageIndex === null || pageIndex === undefined) {
      throw new RequiredError("ListProjectUsersApi", "listProjectUsers", "pageIndex");
    }


    // verify required parameter 'pageSize' is not null or undefined
    if (pageSize === null || pageSize === undefined) {
      throw new RequiredError("ListProjectUsersApi", "listProjectUsers", "pageSize");
    }


    // verify required parameter 'sort' is not null or undefined
    if (sort === null || sort === undefined) {
      throw new RequiredError("ListProjectUsersApi", "listProjectUsers", "sort");
    }


    // verify required parameter 'projectId' is not null or undefined
    if (projectId === null || projectId === undefined) {
      throw new RequiredError("ListProjectUsersApi", "listProjectUsers", "projectId");
    }



    // Path Params
    const localVarPath = '/projects/{projectId}/users'
      .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));

    let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
    // Make Request Context
    const requestContext = _config.baseServer!.makeRequestContext(localVarPath, HttpMethod.GET, signal);
    requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")

    // Query Params
    if (pageIndex !== undefined) {
      requestContext.setQueryParam("pageIndex", ObjectSerializer.serialize(pageIndex, "number", ""));
    }

    // Query Params
    if (pageSize !== undefined) {
      requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
    }

    // Query Params
    if (sort !== undefined) {
      requestContext.setQueryParam("sort", ObjectSerializer.serialize(sort, "string", "tobedefined"));
    }

    // Query Params
    if (filter !== undefined) {
      requestContext.setQueryParam("filter", ObjectSerializer.serialize(filter, "string", "tobedefined"));
    }


    let authMethod: SecurityAuthentication | undefined;
    // Apply auth methods
    authMethod = _config.authMethods!["ApiKeyAuth"]
    if (authMethod?.applySecurityAuthentication) {
      await authMethod?.applySecurityAuthentication(requestContext);
    }

    return requestContext;
  }

}

export class ListProjectUsersApiResponseProcessor {

  /**
   * Unwraps the actual response sent by the server from the response context and deserializes the response content
   * to the expected objects
   *
   * @params response Response returned by the server for a request to listProjectUsers
   * @throws ApiException if the response code was not in [200, 299]
   */
   public async listProjectUsersWithHttpInfo(response: ResponseContext): Promise<HttpInfo<ListUsersResponse >> {
    if (isCodeInRange("200", response.httpStatusCode)) {
      const body: ListUsersResponse = ObjectSerializer.deserialize(
        await response.body.json(),
        "ListUsersResponse", ""
      ) as ListUsersResponse;
      return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    if (isCodeInRange("1XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Informational", undefined, response.headers, response);
    }
    if (isCodeInRange("3XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Redirect", undefined, response.headers, response);
    }
    if (isCodeInRange("4XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Client Error", body, response.headers, response);
    }
    if (isCodeInRange("5XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
    }

    // Work around for missing responses in specification, e.g. for petstore.yaml
    if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
      throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
    }
    const body: ListUsersResponse = await response.body.json() as ListUsersResponse;
    return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
  }

}
